// Default relay for new groups. Empty until a relay is deployed - groups then
// start QR-sync-only and a relay URL can be added later in group settings.
// Set VITE_RELAY_URL at build time once workers/relay is deployed.
export const DEFAULT_RELAY_URL: string =
  (import.meta.env.VITE_RELAY_URL as string | undefined) ?? "";
